import * as Sentry from '@sentry/react';

/**
 * Whether the browser has the CSS features Tailwind CSS v4 relies on: `color-mix()` and `@property`.
 * That is Safari / iOS 16.4+, Chrome / Edge 111+ and Firefox 128+, the supported browsers.
 * On an older browser the app still loads, but its styles are partly or fully ignored.
 */
export const isBrowserSupported = (win: typeof window = window): boolean => (
  typeof win.CSS?.supports === 'function'
  && win.CSS.supports('color', 'color-mix(in lab, red, red)')
  && 'CSSPropertyRule' in win
);

/** Sends a Sentry warning when the browser is not supported, to measure how many users still have one. */
export const reportUnsupportedBrowser = (win: typeof window = window): void => {
  if (isBrowserSupported(win)) {
    return;
  }

  Sentry.captureMessage('Unsupported browser (no color-mix() or @property)', 'warning');
};
